module.exports = __webpack_public_path__ + "static/media/WarningIcon.0471f5dd.svg";